import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';   
import { AuthProvider } from './auth/AuthContext'; 

const ulozenaTema = localStorage.getItem('tema');
const uvodnaTema = ulozenaTema === 'dark' ? 'dark' : 'light';

document.documentElement.setAttribute('data-theme', uvodnaTema);

if (!ulozenaTema) {
  localStorage.setItem('tema', uvodnaTema);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
